import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityNote, EntityNotes } from "@modernary/mui/components/note";
import { withProps } from "@modernary/mui/utils/helpers";
import { RouterView, type RouterOptions } from "vue-router";
import AmendmentRequest from "@/views/amendmentRequest/AmendmentRequest.vue";
import RequestReview from "@/views/distributorReport/RequestReview.vue";
// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  distributorReports: "DistributorReport.DistributorReports",
  list: "DistributorReport.DistributorReportList",
  new: "DistributorReport.DistributorReportNew",
  base: "DistributorReport.DistributorReportBase",
  view: "DistributorReport.DistributorReportView",
  edit: "DistributorReport.DistributorReportEdit",
  updateStatus: "DistributorReport.DistributorReportUpdateStatus",
  reportPayments: "DistributorReport.DistributorReportPayments",
  reportPaymentEdit: "DistributorReport.DistributorReportPaymentEdit",
  reportPaymentNew: "DistributorReport.DistributorReportPaymentNew",
  amendmentRequestNew: "DistributorReport.DistributorAmendmentRequestNew",
  requestReviewNew: "DistributorReport.DistributorRequestReviewNew",
  audit: "DistributorReport.DistributorReportAudit",
  notes: "DistributorReport.DistributorReportNotes",
  noteEdit: "DistributorReport.DistributorReportNoteEdit",
  noteNew: "DistributorReport.DistributorReportNoteNew",
};

export { names as distributorReportRouteNames };

const distributorReportRoutes: RouterOptions["routes"] = [
  {
    path: "/distributorReports",
    name: names.distributorReports,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Distributor Reports",
          lookupGroups: ["ReportPeriod"],
        },
        component: () => import("@/views/distributorReport/DistributorReportList.vue"),
      },
      {
        path: "new/:distributorId(\\d+)?",
        component: () => import("@/views/distributorReport/DistributorReportBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Distributor Report New", isNew: true },
            component: () => import("@/views/distributorReport/DistributorReportEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/distributorReport/DistributorReportBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Distributor Report View" },
            component: () => import("@/views/distributorReport/DistributorReportView.vue"),
          },
          {
            path: "edit", // Also accepts a query param - start = true
            name: names.edit,
            meta: { title: "Distributor Report Edit", isForm: true },
            component: () => import("@/views/distributorReport/DistributorReportEdit.vue"),
          },
          {
            path: "updateStatus", // Also accepts a query param - approve = true, submit=true
            name: names.updateStatus,
            meta: { title: "Distributor Report Edit", isForm: true },
            component: () => import("@/views/distributorReport/DistributorReportStatusUpdate.vue"),
          },
          {
            path: "reportPayments",
            name: names.reportPayments,
            meta: { title: "Distributor Report Payments" },
            component: () => import("@/views/distributorReport/ReportPaymentChildList.vue"),
          },

          {
            path: "reportPayments/:reportPaymentId(\\d+)",
            name: names.reportPaymentEdit,
            meta: { title: "Distributor Report Payment Edit", isForm: true },
            component: () => import("@/views/distributorReport/ReportPaymentEdit.vue"),
          },
          {
            path: "reportPayments/new",
            name: names.reportPaymentNew,
            meta: { title: "Distributor Report Payment New", isForm: true },
            component: () => import("@/views/distributorReport/ReportPaymentEdit.vue"),
          },
          {
            path: "amendmentRequests/new",
            name: names.amendmentRequestNew,
            meta: { title: "Distributor Report Amendment Request", isForm: true },
            component: {
              render: () => <AmendmentRequest />,
            },
          },
          {
            path: "requestReview/new",
            name: names.requestReviewNew,
            meta: { title: "Distributor Report Request Review", isForm: true },
            component: {
              render: () => <RequestReview />,
            },
          },

          {
            path: "activity",
            name: names.audit,
            meta: { title: "Distributor Report Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="DistributorReport" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Distributor Report Notes" },
            component: {
              render: () => (
                <EntityNotes idField="reportId" routeNamePrefix="DistributorReport.DistributorReportNote" />
              ),
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Distributor Report Note", isForm: true },
            ...withProps(async () => (await import("@modernary/mui/components/note")).EntityNote, {
              idField: "reportId",
              listName: names.notes,
            }),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Distributor Report Note", isForm: true },
            ...withProps(async () => (await import("@modernary/mui/components/note")).EntityNote, {
              idField: "reportId",
              listName: names.notes,
            }),
          },
        ],
      },
    ],
  },
];
export default distributorReportRoutes;
